<app-hero></app-hero>
<app-about></app-about>
<app-skills></app-skills>
<app-portfolio></app-portfolio>
<app-contact></app-contact>
